export const requiredPptFileTypes = ['.ppt', '.pptx'];
export const requiredXlsFileTypes = ['.xls', '.xlsx', '.xlsm'];

export const TRAN_DETAIL_UPLOADER_CONFIG = {
    accept: [...requiredPptFileTypes, ...requiredXlsFileTypes].join(','),
    maxFileSizeInBytes: 140 * 1024 * 1024, // 140 MB
    showHttpError: true,
    directoryUpload: false,
    autoUpload: false
};
